export default "__VITE_ASSET__CyZoyHsJ__"